export default __webpack_public_path__ + "static/media/col-image-2_370x489_crop_top.progressive.39279cec.jpg";